// tslint:disable
export enum EnrollmentStatus {
    /**
     * @description Approved Enrollment Status
     */
    Approved = 0,
    /**
     * @description Rejected Enrollment Status
     */
    Rejected = 1,
    /**
     * @description Review Required Enrollment Status
     */
    Review_Required = 2,
    /**
     * @description Case Processing After Review
     */
    Review_Processing = 3,
    /**
     * @description Case Processing After Intake
     */
    Intake_Processing = 4,
    /**
     * @description Disenrolled
     */
    Disenrolled = 5,
    /**
     * @description Enrolled
     */
    Enrolled = 6,
    /**
     * @description Canceled
     */
    Canceled = 7,
    /**
     * @description Open
     */
    Open = 8,
    /**
     * @description Unknown
     */
    Unknown = -1,
    /**
     * @description EXPired
     */
    EXP = 9,
}
(EnrollmentStatus as any)['APPROVED'] = 0;
(EnrollmentStatus as any)['REJECTED'] = 1;
(EnrollmentStatus as any)['REVIEW_REQUIRED'] = 2;
(EnrollmentStatus as any)['REVIEW_PROCESSING'] = 3;
(EnrollmentStatus as any)['INTAKE_PROCESSING'] = 4;
(EnrollmentStatus as any)['DISENROLLED'] = 5;
(EnrollmentStatus as any)['ENROLLED'] = 6;
(EnrollmentStatus as any)['CANCELED'] = 7;
(EnrollmentStatus as any)['OPEN'] = 8;
(EnrollmentStatus as any)['UNKNOWN'] = -1;
